var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "radioCheckContainer" },
      [
        _vm._l(_vm.errors.collect(_vm.question.id), function(error) {
          return _c("p", { key: error, staticClass: "errorText" }, [
            _vm._v("\n        " + _vm._s(error) + "\n    ")
          ])
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.item.propertyValue,
              expression: "item.propertyValue"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { rules: { required: _vm.question.required } },
              expression: "{rules: {'required': question.required}}"
            }
          ],
          class: { error: _vm.errors.has(_vm.question.id) },
          attrs: {
            id: _vm.question.id,
            type: "checkbox",
            value: "TRUE",
            name: _vm.question.id
          },
          domProps: {
            checked: Array.isArray(_vm.item.propertyValue)
              ? _vm._i(_vm.item.propertyValue, "TRUE") > -1
              : _vm.item.propertyValue
          },
          on: {
            __c: function($event) {
              var $$a = _vm.item.propertyValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "TRUE",
                  $$i = _vm._i($$a, $$v)
                if ($$c) {
                  $$i < 0 && (_vm.item.propertyValue = $$a.concat($$v))
                } else {
                  $$i > -1 &&
                    (_vm.item.propertyValue = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.item.propertyValue = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: _vm.question.id } }, [_vm._v(" ")])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5572de01", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5572de01","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileBooleanEditor.vue
// module id = 565
// module chunks = 2